<div class="editor-content">
    <ul nz-menu nzMode="inline" class="p-1">
        <li nz-submenu nzTitle="Ẩn hiện" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
            <div class="switch-image px-2 d-flex justify-content-between">
                <span class="title">
                    Ẩn ở trang Mobile<br />
                    <span style="font-size: 12px;">(Khi xem bản live)</span>
                </span>
                <nz-switch style="line-height: 40px;" [(ngModel)]="data_tool.mobile_portrait_hidden"
                    (ngModelChange)="updateHidden({mobile_portrait_hidden: $event})"></nz-switch>
            </div>

            <div class="switch-image px-2 d-flex justify-content-between">
                <span class="title">Ẩn khi đếm xong</span>
                <nz-switch style="line-height: 40px;" [(ngModel)]="data_tool.data.display_object"
                    (ngModelChange)="updateCss('data',data_tool.data)"></nz-switch>
            </div>

            <div class="switch-image px-2 d-flex justify-content-between">
                <span class="title" style="line-height: 1.5;">Ẩn trước cho đến khi thời gian bắt đầu </span>
                <nz-switch style="line-height: 40px;" [(ngModel)]="data_tool.data.display_now"
                    (ngModelChange)="updateDisplay()"></nz-switch>
            </div>
        </li>
        <!-- Cấu hình cơ bản -->
        <li nz-submenu nzTitle="Số và định dạng" *ngIf="data_tool.data.option == 0" [nzOpen]="true" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
            <div class="editor-field">
                <div class="editor-field-body p-1" style="line-height: 15px;">
                    <div class="field-row d-flex justify-content-around ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p>Quản lý bộ đếm <br><span style="font-size: 11px;">(trong trang admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="field-row switch-image-sub" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 mt-2">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                    <div class="field-row d-flex  my-2 justify-content-around">
                        <p> {{'hien_thi' | translate}} định dạng <span style="font-size: 11px;">(Ngày/Giờ/Phút/Giây)</span> </p>
                        <nz-switch [(ngModel)]="data_tool.format_countdown_daytime"
                            (ngModelChange)="updateFormat('format_countdown_daytime',data_tool.format_countdown_daytime)"></nz-switch>
                    </div>
                    <div class="field-row d-flex justify-content-around">
                        <p> {{'hien_thi' | translate}} định dạng mặc định (:)</p>
                        <nz-switch [(ngModel)]="data_tool.format_countdown_default"
                            (ngModelChange)="updateFormat('format_countdown_default',data_tool.format_countdown_default)"></nz-switch>
                    </div>
                    <div class="field-row">
                        <div class="config-font">
                            <div class="my-4">
                                <nz-col nzSpan="24" class="d-flex">
                                    <mat-form-field style="width: 60%;" class="mr-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_text.font_family"
                                            (ngModelChange)="updateCss('desktop_format_text',data_tool.desktop_format_text)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width: 35%;">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_text.font_size"
                                            (ngModelChange)="updateCss('desktop_format_text',data_tool.desktop_format_text)"
                                            [min]="1" [max]="100" />
                                    </mat-form-field>
                                </nz-col>
                            </div>
                        </div>
                    </div>
                    <div class="field-row">
                        <div class="config-font">
                            <p class="title">Kiểu chữ:</p>
                            <div class="font config-font-countdown" style="gap: 5px">

                                <button style= "min-width: 30px; font-size: 14px" class="font-text-btn font-text-btn-bold" title="bold"
                                    nz-button (blur)="updateCss('desktop_format_text',data_tool.desktop_format_text)"
                                    [nzType]="data_tool.desktop_format_text.font_weight == 'bold' ? 'primary': 'default'"
                                    (click)="data_tool.desktop_format_text.font_weight =  data_tool.desktop_format_text.font_weight == 'bold' ? '500' : 'bold'; ">
                                    B
                                </button>
                                <button style="font-size: 14px" class="font-text-btn font-text-btn-italic"
                                    title="Italic" nz-button
                                    (blur)="updateCss('desktop_format_text',data_tool.desktop_format_text)"
                                    [nzType]="data_tool.desktop_format_text.font_style == 'italic' ? 'primary': 'default'"
                                    (click)="data_tool.desktop_format_text.font_style =  data_tool.desktop_format_text.font_style  == 'normal' ? 'italic' :'normal' ">
                                    <i nz-icon nzType="italic" nzTheme="outline"></i>
                                </button>
                                <button style="font-size: 14px" class="font-text-btn font-text-btn-underline"
                                    title="Underline" nz-button
                                    (blur)="updateCss('desktop_format_text',data_tool.desktop_format_text)"
                                    [nzType]="data_tool.desktop_format_text.decoration == 'underline' ? 'primary': 'default'"
                                    (click)="data_tool.desktop_format_text.decoration =  data_tool.desktop_format_text.decoration == 'none'? 'underline' :'none' ">
                                    <i nz-icon nzType="underline" nzTheme="outline"></i>
                                </button>
                                <button style="min-width: 30px; font-size: 14px" class="font-text-btn font-text-btn-bold" nz-button
                                    (click)="openColor('color')" title="color">
                                    <input type="color" id="color"
                                        (blur)="updateCss('desktop_format_text',data_tool.desktop_format_text)"
                                        [(ngModel)]="data_tool.desktop_format_text.color" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="field-row">
                        <div class="config-font">
                            <div class="font-text-letterspacing">
                                <div class="config-name">
                                    <p class="m-0 title">Khoảng cách dòng:</p>
                                    <nz-input-number [(ngModel)]="data_tool.desktop_format_text.line_spacing"
                                        [nzMin]="10" [nzMax]="100">
                                        (ngModelChange)="updateCss('desktop_format_text',data_tool.desktop_format_text)"
                                    </nz-input-number>
                                </div>
                                <nz-row>
                                    <nz-col nzSpan="24">
                                        <nz-slider [nzMin]="10" [nzMax]="100"
                                            [(ngModel)]="data_tool.desktop_format_text.line_spacing"
                                            (ngModelChange)="updateCss('desktop_format_text',data_tool.desktop_format_text)">
                                        </nz-slider>
                                    </nz-col>
                                </nz-row>
                            </div>
                        </div>
                    </div>
                    <div class="field-row">
                        <div class="config-font">
                            <div class="font-text-letterspacing">
                                <div class="config-name">
                                    <p class="m-0 title">Khoảng cách chữ:</p>
                                    <nz-input-number [(ngModel)]="data_tool.desktop_format_text.letter_spacing"
                                        [nzMin]="0" [nzMax]="50">
                                        (ngModelChange)="updateCss('desktop_format_text',data_tool.desktop_format_text)"
                                    </nz-input-number>
                                </div>
                                <nz-row>
                                    <nz-col nzSpan="24">
                                        <nz-slider [nzMin]="0" [nzMax]="50"
                                            [(ngModel)]="data_tool.desktop_format_text.letter_spacing"
                                            (ngModelChange)="updateCss('desktop_format_text',data_tool.desktop_format_text)">
                                        </nz-slider>
                                    </nz-col>
                                </nz-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li nz-submenu nzTitle="Các kiểu nâng cao" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
            <div class="editor-field box-shadow">
                <div class="editor-field-body">
                    <div class="field-row">
                        <div class="field-content-slide w-100">
                            <div class="list-box">
                                <div class="box" *ngFor="let item of option_style;let i = index">
                                    <div class="box-item square"
                                        [ngClass]="data_tool.data.option == i+1 ? 'selected' : null"
                                        (click)="SelectedOption(item.option,$event)">
                                        <div class="content">
                                            <img [src]="item.img" />
                                        </div>
                                    </div>
                                    <div class="box-name" style="z-index: 5;">{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <!-- config option 1 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 1" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Màu nền ô số">
                    <div class="contains">
                        <div class="box-add">
                            <button class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_1.background_in"
                                    class="input-color" id="input-color" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgIn(background,'desktop_format_option_1', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Màu nền viền">
                    <div class="contains" id="contains">
                        <div class="box-add">
                            <button tton class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color-1')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_1.background_out"
                                    class="input-color" id="input-color-1" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgOut(background,'desktop_format_option_1', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_1.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_1.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_1.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">
                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                            [nzType]="data_tool.desktop_format_option_1.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.font_weight_text =  data_tool.desktop_format_option_1.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                            [nzType]="data_tool.desktop_format_option_1.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.font_style_text =  data_tool.desktop_format_option_1.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                            [nzType]="data_tool.desktop_format_option_1.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.decoration_text =  data_tool.desktop_format_option_1.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_1.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.transform_text =  data_tool.desktop_format_option_1.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input class="color-input" style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                                [(ngModel)]="data_tool.desktop_format_option_1.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_1.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_1.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_1.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_1.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_1.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_1.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                            [nzType]="data_tool.desktop_format_option_1.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.font_weight_number =  data_tool.desktop_format_option_1.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                            [nzType]="data_tool.desktop_format_option_1.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.font_style_number =  data_tool.desktop_format_option_1.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                            [nzType]="data_tool.desktop_format_option_1.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.decoration_number =  data_tool.desktop_format_option_1.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_1.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_1.transform_number =  data_tool.desktop_format_option_1.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input class="color-input" type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_1',data_tool.desktop_format_option_1)"
                                                [(ngModel)]="data_tool.desktop_format_option_1.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>

        <!-- config option 2 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 2" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Màu nền ô số">
                    <h3 class="title-bgColor">Bảng màu</h3>
                    <div class="contains">
                        <div class="box-add">
                            <button class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_2.background_in"
                                    class="input-color" id="input-color" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgIn(background,'desktop_format_option_2', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Màu nền viền">
                    <h3 class="title-bgColor">Bảng màu</h3>
                    <div class="contains" id="contains">
                        <div class="box-add">
                            <button tton class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color-2')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_2.background_out"
                                    class="input-color" id="input-color-2" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgOut(background,'desktop_format_option_2', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_2.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_2.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_2.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                            [nzType]="data_tool.desktop_format_option_2.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.font_weight_text =  data_tool.desktop_format_option_2.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                            [nzType]="data_tool.desktop_format_option_2.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.font_style_text =  data_tool.desktop_format_option_2.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                            [nzType]="data_tool.desktop_format_option_2.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.decoration_text =  data_tool.desktop_format_option_2.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_2.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.transform_text =  data_tool.desktop_format_option_2.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                                [(ngModel)]="data_tool.desktop_format_option_2.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_2.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_2.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_2.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_2.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_2.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_2.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                            [nzType]="data_tool.desktop_format_option_2.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.font_weight_number =  data_tool.desktop_format_option_2.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                            [nzType]="data_tool.desktop_format_option_2.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.font_style_number =  data_tool.desktop_format_option_2.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                            [nzType]="data_tool.desktop_format_option_2.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.decoration_number =  data_tool.desktop_format_option_2.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_2.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_2.transform_number =  data_tool.desktop_format_option_2.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_2',data_tool.desktop_format_option_2)"
                                                [(ngModel)]="data_tool.desktop_format_option_2.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <!-- config option 3 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 3" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Màu nền ô số">
                    <h3 class="title-bgColor">Bảng màu</h3>
                    <div class="contains">
                        <div class="box-add">
                            <button class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_3.background_in"
                                    class="input-color" id="input-color" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgIn(background,'desktop_format_option_3', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Màu nền viền">
                    <h3 class="title-bgColor">Bảng màu</h3>
                    <div class="contains" id="contains">
                        <div class="box-add">
                            <button tton class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color-3')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_3.background_out"
                                    class="input-color" id="input-color-3" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgOut(background,'desktop_format_option_3', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_3.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_3.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_3.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                            [nzType]="data_tool.desktop_format_option_3.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.font_weight_text =  data_tool.desktop_format_option_3.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                            [nzType]="data_tool.desktop_format_option_3.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.font_style_text =  data_tool.desktop_format_option_3.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                            [nzType]="data_tool.desktop_format_option_3.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.decoration_text =  data_tool.desktop_format_option_3.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_3.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.transform_text =  data_tool.desktop_format_option_3.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                                [(ngModel)]="data_tool.desktop_format_option_3.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_3.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_3.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_3.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_3.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_3.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_3.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                            [nzType]="data_tool.desktop_format_option_3.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.font_weight_number =  data_tool.desktop_format_option_3.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                            [nzType]="data_tool.desktop_format_option_3.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.font_style_number =  data_tool.desktop_format_option_3.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                            [nzType]="data_tool.desktop_format_option_3.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.decoration_number =  data_tool.desktop_format_option_3.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_3.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_3.transform_number =  data_tool.desktop_format_option_3.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_3',data_tool.desktop_format_option_3)"
                                                [(ngModel)]="data_tool.desktop_format_option_3.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>

        <!-- config option 4 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 4" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Màu nền viền">
                    <div class="contains" id="contains">
                        <div class="box-add">
                            <button tton class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color-4')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_4.background_out"
                                    class="input-color" id="input-color-4" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgOut(background,'desktop_format_option_4', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_4.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_4.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_4.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                            [nzType]="data_tool.desktop_format_option_4.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.font_weight_text =  data_tool.desktop_format_option_4.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                            [nzType]="data_tool.desktop_format_option_4.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.font_style_text =  data_tool.desktop_format_option_4.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                            [nzType]="data_tool.desktop_format_option_4.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.decoration_text =  data_tool.desktop_format_option_4.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_4.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.transform_text =  data_tool.desktop_format_option_4.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                                [(ngModel)]="data_tool.desktop_format_option_4.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_4.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_4.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_4.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_4.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_4.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_4.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                            [nzType]="data_tool.desktop_format_option_4.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.font_weight_number =  data_tool.desktop_format_option_4.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                            [nzType]="data_tool.desktop_format_option_4.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.font_style_number =  data_tool.desktop_format_option_4.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                            [nzType]="data_tool.desktop_format_option_4.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.decoration_number =  data_tool.desktop_format_option_4.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_4.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_4.transform_number =  data_tool.desktop_format_option_4.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_4',data_tool.desktop_format_option_4)"
                                                [(ngModel)]="data_tool.desktop_format_option_4.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <!-- config option 5 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 5" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Màu nền ô số">
                    <div class="contains">
                        <div class="box-add">
                            <button class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_5.background_in"
                                    class="input-color" id="input-color" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgIn(background,'desktop_format_option_5', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Màu nền viền">
                    <div class="contains" id="contains">
                        <div class="box-add">
                            <button tton class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color-5')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_5.background_out"
                                    class="input-color" id="input-color-5" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgOut(background,'desktop_format_option_5', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_5.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_5.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_5.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                            [nzType]="data_tool.desktop_format_option_5.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.font_weight_text =  data_tool.desktop_format_option_5.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                            [nzType]="data_tool.desktop_format_option_5.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.font_style_text =  data_tool.desktop_format_option_5.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                            [nzType]="data_tool.desktop_format_option_5.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.decoration_text =  data_tool.desktop_format_option_5.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_5.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.transform_text =  data_tool.desktop_format_option_5.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                                [(ngModel)]="data_tool.desktop_format_option_5.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_5.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_5.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_5.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_5.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_5.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_5.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                            [nzType]="data_tool.desktop_format_option_5.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.font_weight_number =  data_tool.desktop_format_option_5.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                            [nzType]="data_tool.desktop_format_option_5.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.font_style_number =  data_tool.desktop_format_option_5.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                            [nzType]="data_tool.desktop_format_option_5.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.decoration_number =  data_tool.desktop_format_option_5.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_5.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_5.transform_number =  data_tool.desktop_format_option_5.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_5',data_tool.desktop_format_option_5)"
                                                [(ngModel)]="data_tool.desktop_format_option_5.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <!-- config option 6 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 6" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                                <span nz-icon nzType="info-circle" nzTheme="outline" nz-tooltip
                                    nzTooltipTitle="Dữ liệu sẽ được lưu trên cloud server, điều này có thể gây ra chậm việc {{'hien_thi' | translate}} nội dung! Nếu đây là nội dung không thay đổi vui lòng tắt chức năng này!"></span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Màu nền ô số">
                    <h3 class="title-bgColor">Bảng màu</h3>
                    <div class="contains">
                        <div class="box-add">
                            <button class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_6.background_in"
                                    class="input-color" id="input-color" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgIn(background,'desktop_format_option_6', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Màu nền viền">
                    <h3 class="title-bgColor">Bảng màu</h3>
                    <div class="contains" id="contains">
                        <div class="box-add">
                            <button tton class="add-bgColor" nz-tooltip nzTooltipTitle="Chọn màu"
                                (click)="openBgColor('input-color-6')">
                                <input type="color" [(ngModel)]="data_tool.desktop_format_option_6.background_out"
                                    class="input-color" id="input-color-6" />
                                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                            </button>
                        </div>
                        <div class="box-background" *ngFor="let background of backgroundColor; let i = index">
                            <button id="button-backgroundCl" [ngStyle]="{'background-color':background.bgColor}"
                                (click)="chooseBgOut(background,'desktop_format_option_6', $event)" nz-tooltip
                                nzTooltipTitle="{{background.name}} {{background.hex}}"></button>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_6.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_6.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_6.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                            [nzType]="data_tool.desktop_format_option_6.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.font_weight_text =  data_tool.desktop_format_option_6.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                            [nzType]="data_tool.desktop_format_option_6.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.font_style_text =  data_tool.desktop_format_option_6.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                            [nzType]="data_tool.desktop_format_option_6.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.decoration_text =  data_tool.desktop_format_option_6.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_6.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.transform_text =  data_tool.desktop_format_option_6.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                                [(ngModel)]="data_tool.desktop_format_option_6.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_6.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_6.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_6.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_6.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_6.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_6.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                            [nzType]="data_tool.desktop_format_option_6.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.font_weight_number =  data_tool.desktop_format_option_6.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                            [nzType]="data_tool.desktop_format_option_6.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.font_style_number =  data_tool.desktop_format_option_6.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                            [nzType]="data_tool.desktop_format_option_6.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.decoration_number =  data_tool.desktop_format_option_6.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_6.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_6.transform_number =  data_tool.desktop_format_option_6.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_6',data_tool.desktop_format_option_6)"
                                                [(ngModel)]="data_tool.desktop_format_option_6.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <!-- config option 7 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 7" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_7.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_7.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_7.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                            [nzType]="data_tool.desktop_format_option_7.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.font_weight_text =  data_tool.desktop_format_option_7.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                            [nzType]="data_tool.desktop_format_option_7.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.font_style_text =  data_tool.desktop_format_option_7.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                            [nzType]="data_tool.desktop_format_option_7.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.decoration_text =  data_tool.desktop_format_option_7.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_7.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.transform_text =  data_tool.desktop_format_option_7.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                                [(ngModel)]="data_tool.desktop_format_option_7.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_7.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_7.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_7.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_7.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_7.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_7.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                            [nzType]="data_tool.desktop_format_option_7.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.font_weight_number =  data_tool.desktop_format_option_7.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                            [nzType]="data_tool.desktop_format_option_7.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.font_style_number =  data_tool.desktop_format_option_7.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                            [nzType]="data_tool.desktop_format_option_7.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.decoration_number =  data_tool.desktop_format_option_7.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_7.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_7.transform_number =  data_tool.desktop_format_option_7.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_7',data_tool.desktop_format_option_7)"
                                                [(ngModel)]="data_tool.desktop_format_option_7.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <!-- config option 8 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 8" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_8.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_8.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_8.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                            [nzType]="data_tool.desktop_format_option_8.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.font_weight_text =  data_tool.desktop_format_option_8.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                            [nzType]="data_tool.desktop_format_option_8.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.font_style_text =  data_tool.desktop_format_option_8.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                            [nzType]="data_tool.desktop_format_option_8.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.decoration_text =  data_tool.desktop_format_option_8.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_8.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.transform_text =  data_tool.desktop_format_option_8.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                                [(ngModel)]="data_tool.desktop_format_option_8.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_8.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_8.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_8.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_8.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_8.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_8.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                            [nzType]="data_tool.desktop_format_option_8.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.font_weight_number =  data_tool.desktop_format_option_8.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                            [nzType]="data_tool.desktop_format_option_8.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.font_style_number =  data_tool.desktop_format_option_8.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                            [nzType]="data_tool.desktop_format_option_8.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.decoration_number =  data_tool.desktop_format_option_8.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_8.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_8.transform_number =  data_tool.desktop_format_option_8.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_8',data_tool.desktop_format_option_8)"
                                                [(ngModel)]="data_tool.desktop_format_option_8.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <!-- config option 9 -->
        <li nz-submenu nzTitle="Cấu hình nâng cao" [nzOpen]="true" *ngIf="data_tool.data.option == 9" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <ul class="p-2">
                <div class="option_hidden">
                    <div class="field-row d-flex justify-content-between ">
                        <div class="custom-label" [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data',$event)">
                            <p style="font-size: 13px;">Quản lý nội dung <br><span style="font-size: 11px;">(trong trang
                                    admin)</span>
                            </p>
                        </div>
                        <nz-switch [(ngModel)]="data_tool.dynamic_data"
                            (ngModelChange)="updateDynamic('dynamic_data', $event)"></nz-switch>
                    </div>
                    <div class="switch-image-sub mt-2" *ngIf="data_tool.dynamic_data">
                        <mat-form-field class="example-full-width w-100 ">
                            <mat-label>Tên trong Admin</mat-label>
                            <input matInput style="font-size: 13px;" [(ngModel)]="data_tool.name"
                                (blur)="updateDynamic('caname',data_tool.name)" />
                        </mat-form-field>
                    </div>
                </div>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu chữ">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <p class="title" style="line-height: 15px; font-size:13px " nz-checkbox
                                    [(ngModel)]="data_tool.desktop_format_option_9.format_countdown"
                                    (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)">
                                    {{'hien_thi' | translate}} định dạng <span style="font-size: 12px;">(Ngày/Giờ/Phút/Giây)</span>
                                </p>
                            </div>
                            <div class="field-row">
                                <div class="config-font mt-2">
                                    <nz-row class="d-flex justify-content-around">
                                        <mat-form-field style="width:60%">
                                            <mat-label>Font</mat-label>
                                            <mat-select [(ngModel)]="data_tool.desktop_format_option_9.font_family_text"
                                                style="min-width: 10%;"
                                                (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)">
                                                <mat-option *ngFor="let font of fonts"
                                                    [value]="font.value">{{font.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field style="width:35%">
                                            <mat-label>Kích thước</mat-label>
                                            <input matInput type="number"
                                                [(ngModel)]="data_tool.desktop_format_option_9.font_size_text"
                                                (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                                [min]="1" [max]="100">
                                        </mat-form-field>
                                    </nz-row>
                                </div>

                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ:</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                            [nzType]="data_tool.desktop_format_option_9.font_weight_text == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.font_weight_text =  data_tool.desktop_format_option_9.font_weight_text == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                            [nzType]="data_tool.desktop_format_option_9.font_style_text == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.font_style_text =  data_tool.desktop_format_option_9.font_style_text  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                            [nzType]="data_tool.desktop_format_option_9.decoration_text == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.decoration_text =  data_tool.desktop_format_option_9.decoration_text == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_9.transform_text == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.transform_text =  data_tool.desktop_format_option_9.transform_text == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1')" title="color">
                                            <input style="display:block" type="color" id="color-1"
                                                (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                                [(ngModel)]="data_tool.desktop_format_option_9.color_text" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách dòng</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_9.line_spacing_text"
                                                [nzMin]="10" [nzMax]="100"
                                                (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="10" [nzMax]="100"
                                                    [(ngModel)]="data_tool.desktop_format_option_9.line_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <div class="font-text-letterspacing">
                                        <div class="config-name">
                                            <p class="m-0 title">Khoảng cách chữ</p>
                                            <nz-input-number
                                                [(ngModel)]="data_tool.desktop_format_option_9.letter_spacing_text"
                                                [nzMin]="0" [nzMax]="50"
                                                (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [(ngModel)]="data_tool.desktop_format_option_9.letter_spacing_text"
                                                    (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"></nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li nz-submenu nzTitle="Chỉnh sửa kiểu số">
                    <div class="editor-field">
                        <div class="editor-field-body">
                            <div class="field-row">
                                <div class="config-font d-flex ">
                                    <mat-form-field style="width:60%" class="mx-1">
                                        <mat-label>Font</mat-label>
                                        <mat-select [(ngModel)]="data_tool.desktop_format_option_9.font_family_number"
                                            style="min-width: 10%;"
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)">
                                            <mat-option *ngFor="let font of fonts"
                                                [value]="font.value">{{font.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field style="width:35%">
                                        <mat-label>Kích thước</mat-label>
                                        <input matInput type="number"
                                            [(ngModel)]="data_tool.desktop_format_option_9.font_size_number"
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                            [min]="1" [max]="100">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="config-font">
                                    <p class="title">Kiểu chữ</p>
                                    <div class="font">

                                        <button class="font-text-btn font-text-btn-bold" title="bold" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                            [nzType]="data_tool.desktop_format_option_9.font_weight_number == 'bold' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.font_weight_number =  data_tool.desktop_format_option_9.font_weight_number == 'bold' ? '500' : 'bold'; ">
                                            B
                                        </button>
                                        <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                            [nzType]="data_tool.desktop_format_option_9.font_style_number == 'italic' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.font_style_number =  data_tool.desktop_format_option_9.font_style_number  == 'normal' ? 'italic' :'normal' ">
                                            <i nz-icon nzType="italic" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-underline" title="Underline"
                                            nz-button
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                            [nzType]="data_tool.desktop_format_option_9.decoration_number == 'underline' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.decoration_number =  data_tool.desktop_format_option_9.decoration_number == 'none'? 'underline' :'none' ">
                                            <i nz-icon nzType="underline" nzTheme="outline"></i>
                                        </button>
                                        <button class="font-text-btn font-text-btn-transform" nz-button
                                            [nzType]="data_tool.desktop_format_option_9.transform_number == 'uppercase' ? 'primary': 'default'"
                                            (click)="data_tool.desktop_format_option_9.transform_number =  data_tool.desktop_format_option_9.transform_number == 'none'? 'uppercase' :'none' "
                                            (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)">
                                            <img class="icon-text" src="../../../../../assets/root/icon/user/uppercase.png"
                                                alt="" />
                                        </button>
                                        <button class="font-text-btn font-text-btn-bold" nz-button
                                            (click)="openColor('color-1-text')" title="color">
                                            <input type="color" id="color-1-text"
                                                (ngModelChange)="updateCss('desktop_format_option_9',data_tool.desktop_format_option_9)"
                                                [(ngModel)]="data_tool.desktop_format_option_9.color_number" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </li>
        <li nz-submenu nzTitle="Thiết lập thời gian" *ngIf="!data_tool.dynamic_data" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
            <div class="config_time">
                <div class="config_day">
                    <p class="title">Thời gian bắt đầu đếm ngược:</p>
                    <input style="margin: 0.4rem 0; width: 100%; font: initial;" [(ngModel)]="dateStart"
                        type="datetime-local" (blur)="CheckDayInput($event.target['value'])" />
                </div>

                <div class="config_day">
                    <p class="title">Thời gian kết thúc đếm ngược:</p>
                    <input style="margin: 0.4rem 0; width: 100%; font: initial;" [(ngModel)]="dateEnd"
                        type="datetime-local" (blur)="CheckDayEnd($event.target['value'])" />
                </div>
            </div>
            <div class="button">
                <button nz-button nzBlock nzType="default" (click)="SetTime()">CẬP NHẬT</button>
            </div>
        </li>
    </ul>
</div>
<!-- [disabled]="checkTimeIsCorrect" -->
